// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__AcWGP","footerSeparator":"Footer_footerSeparator__Uw5bi","link":"Footer_link__ljLIL"};